import { useCompanyContext } from '~contexts/CompanyContext';

export function useCompanyId() {
  return useCompanyContext();
}
